import createVueApp from '../../shared/vue/create-app';
import {store} from '../../store/global-store';
import initAdvertModalComponents from './advert-modals';
import initCustomInputsComponents from '../inputs/custom-inputs';
import initCustomControls from '../custom-controls';
import {Field} from 'vee-validate';
import {initCurrencyPriceComponents} from '../inputs/currency-price';
import initAddressSelectorComponent from '../inputs/address-selector';

function initAdvertModals(options) {
    const app = createVueApp({
        methods: {
            redirectToDeletedPage(url) {
                window.location = url;
            },
        },
        mounted() {
            store.subscribe((mutation) => {
                if (mutation.type === 'openHideModal') {
                    this.$refs.confirmHideListing.open(mutation.payload.acceptAction);
                }
            });
        },
    });

    app.component('Field', Field);
    initAdvertModalComponents(app);
    initCustomInputsComponents(app);
    initCustomControls(app);
    initCurrencyPriceComponents(app);
    initAddressSelectorComponent(app);

    app.mount(options.el);

    return app;
}


export {initAdvertModals};
